//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import mobileYzm from '/src/views/login/components/mobile-yzm'

export default {
    components: {mobileYzm},
    props:{

    },
    data: () => ({
        upadtePwdForm:{},
    }),
    methods: {
        handlerClick:function(){
            let that = this 
            that.$refs['upadtePwdForm'].validate(function (valid) {
                if(valid){
                    that.$post(that.$store.getters.userUrl + '/changeMobile',that.upadtePwdForm,function(data){
                        ShowMsg('修改成功','success');
                        that.$emit('setUpadteLogin');
                    },true)
                }
            })
        },
        goLogin:function(){
            this.$emit('setUpadteLogin');
        }
    },
    mounted () {

    }
}
